<template>
    <div class="flex flex-wrap max-w-4xl mx-auto items-center">

        <div class="w-full p-8" >
            <div class="pt-2 flex flex-wrap" >
                <div class="w-1/4 px-2 border-b-2 border-blue-500 pb-2 cursor-pointer" v-for="dealImage in deal.deal_images">
                    <img :src="route('deal.show.image', {deal, dealImage})" onerror="this.onerror=null;this.src='/img/comingsoon.gif';" class="mx-auto w-auto border-4 border-gray-400"/>
                </div>
            </div>
        </div>
        <div class="w-full">
            <div v-if="show_title">
                <h1 class="text-center" style="line-height: normal">{{ deal.name }}</h1>
            </div>

            <p class="pb-4 my-2" v-if="deal.description">{{ deal.description }}</p>
            <p class="pb-4 my-2" v-if="deal.ai_description" v-html="deal.ai_description"></p>

            <div class="pt-2" v-if="deal.has_file">

            <div v-if="contains_xlsx">
                <iframe :data-src="'https://view.officeapps.live.com/op/embed.aspx?src=' + route('deal.show.file', deal)" class="auction-detail__preview-excel" width="100%" height="556px" frameborder="0" :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + route('deal.show.file', deal)"></iframe>
            </div>

            <a :href="route('deal.show.file', deal)">
                <button class="fw-btn fw-btn-green w-full my-2"
                        style="outline: none;"><i class="fas fa-download px-2"></i> Download Product List
                </button>
            </a>
            </div>

            <div class="pt-4" v-if="deal.status !== 'auction'">
                <a onclick="return confirm('Are you sure you wish to buy this now? First come first serve basis, we will contact you if your purchase is successful.')" :href="route('deal.buy-now', deal)">
                    <button class="fw-btn fw-btn-green w-full"
                            style="outline: none;">Buy Now (First come, first served)
                    </button>
                </a>
            </div>

            <div class="pt-4" v-if="deal.accepts_offers && deal.status !== 'auction'">
                <a :href="route('deal.offer', deal)">
                    <button class="fw-btn fw-btn-green w-full"
                            style="outline: none;">Make an offer
                    </button>
                </a>
            </div>

            <!-- <p>**Product list available on request**</p> -->
            <div class="pt-4" v-if="deal.status !== 'auction'">
                <a :href="route('deal.contact', deal)" >
                    <button class="fw-btn fw-btn-green w-full"
                            style="outline: none;">Contact Me
                    </button>
                </a>
            </div>

            <div class="text-xs text-center pt-4 text-gray-300" v-if="deal.status !== 'auction'">
                <p>By clicking the button above you agree to be contacted by a member of our sales team.</p>
            </div>

            <div class="pt-4" v-if="show_bid_button">
                <a :href="route('deal.bid', deal)" v-if="deal.status === 'auction'">
                    <button class="fw-btn fw-btn-green w-full"
                            style="outline: none;">Place Bid
                    </button>
                </a>
            </div>

        </div>
    </div>





</template>
<script>
export default {
    props: {
        deal: {
            required: true,
            type: Object
        },
        similar_deals: {
            type: Array
        },
        contains_xlsx: {
            required: false,
            type: Boolean,
            default: false
        },
        show_bid_button: {
            required: false,
            type: Boolean,
            default: true
        },
        show_title: {
            required: false,
            type: Boolean,
            default: true
        }
    }
}
</script>
